window.ACFUP_CONFIG = {
  "version": "2026-10-30-approved-addon-prices",
  "enabled": false,
  "endpoint": null,
  "previewOnly": true,
  "purchaseEnabled": false,
  "products": [
    {
      "key": "iwe",
      "title": "Instant Wrinkle Eraser",
      "description": "Pair your Advanced Crepe Fix body-care routine with a temporary cosmetic smoothing step for the look of under-eye lines.",
      "image": "assets/acfup-iwe.png",
      "imageAlt": "Instant Wrinkle Eraser product packshot",
      "provenance": {
        "source": "https://miamimd.co/assets/images/products/instant-wrinkle-eraser/instant-wrinkle-eraser-shopImg.png",
        "sourcePackPath": "iwe/iwe_packshot_1.png",
        "status": "live-on-brand-site",
        "sha256": "7ae9a8de51dae370f79cde0db6e8352a5d8c918e56575b995e56128b2484be76",
        "packagingApproved": false
      },
      "productId": "15485379182877",
      "variantId": 67912012398877,
      "catalogPriceCents": 3300,
      "catalogPriceStatus": "Current catalog price matches approved one-time preview offer; purchasing and fulfillment remain disabled",
      "approvedOfferPriceCents": 3300,
      "sellingPlanId": null,
      "warehouseVerified": false,
      "previewOnly": true,
      "purchaseEnabled": false,
      "routineRole": "Eye-area finishing touch",
      "copySource": "https://miamimd.co/instant-wrinkle-eraser",
      "contextDescription": {
        "acf": "Advanced Crepe Fix is your body-care choice. Instant Wrinkle Eraser is a separate optional cosmetic step for the appearance of under-eye lines.",
        "lf": "Alongside your Lift & Firm facial-care routine, explore an optional cosmetic step for the appearance of under-eye lines."
      },
      "catalogPreviousReference": {
        "productId": "15479672832285",
        "variantId": null,
        "catalogPriceCents": 6900
      },
      "sku": "MMIWE-1B",
      "handle": "miamimd-instant-wrinkle-eraser-1-bottle-special",
      "catalogFamily": "special",
      "catalogSource": "https://crepe.trymiamimd.com/products/miamimd-instant-wrinkle-eraser-1-bottle-special.js",
      "publicPlanReadbackVerified": false,
      "fulfillmentVerificationRequired": true,
      "pricingApproved": true,
      "priceComparison": {
        "referencePriceCents": 6900,
        "savingCents": 3600,
        "savingPercentRounded": 52,
        "context": "Current MiamiMD.co one-bottle Buy Once price",
        "source": "https://miamimd.co/instant-wrinkle-eraser",
        "verifiedDate": "2026-10-29"
      },
      "offerQuantity": 1,
      "catalogPriceVerifiedDate": "2026-10-30",
      "offerPriceApprovedDate": "2026-10-30"
    },
    {
      "key": "tbm",
      "title": "Total Beauty Matrix",
      "description": "Complement your topical Advanced Crepe Fix routine from within. TBM provides 225 mg of vitamin C per two-capsule serving to support normal collagen formation.*",
      "image": "assets/acfup-tbm.png",
      "imageAlt": "Total Beauty Matrix product packshot",
      "provenance": {
        "source": "trymiamimd.com live page",
        "sourcePackPath": "total-beauty-matrix/live-v42-upsell2-tbm/assets/total-beauty-matrix-single.Dig5jElB.png",
        "status": "statsig-variant",
        "sha256": "703b0a045fd1332dcf0292cb14fb0d95d9b4fec7c9c8c4310dc41444e8424751",
        "packagingApproved": false
      },
      "productId": "15485392257309",
      "variantId": 67912160608541,
      "catalogPriceCents": 3300,
      "catalogPriceStatus": "Current catalog price matches approved one-time preview offer; purchasing and fulfillment remain disabled",
      "approvedOfferPriceCents": 3300,
      "sellingPlanId": null,
      "warehouseVerified": false,
      "previewOnly": true,
      "purchaseEnabled": false,
      "routineRole": "Nutritional collagen support",
      "copySource": "https://miamimd.co/total-beauty-matrix",
      "contextDescription": {
        "acf": "An optional nutrition choice. TBM provides 225 mg of vitamin C per two-capsule serving to support normal collagen formation.*",
        "lf": "An optional nutrition choice alongside topical facial care. TBM provides 225 mg of vitamin C per two-capsule serving to support normal collagen formation.*"
      },
      "catalogPreviousReference": {
        "productId": "15479671685405",
        "variantId": null,
        "catalogPriceCents": 6900
      },
      "sku": "MMTBM-1B",
      "handle": "miamimd-total-beauty-matrix-1-jar-special",
      "catalogFamily": "special",
      "catalogSource": "https://crepe.trymiamimd.com/products/miamimd-total-beauty-matrix-1-jar-special.js",
      "publicPlanReadbackVerified": false,
      "fulfillmentVerificationRequired": true,
      "pricingApproved": true,
      "offerQuantity": 1,
      "catalogPriceVerifiedDate": "2026-10-30",
      "offerPriceApprovedDate": "2026-10-30"
    },
    {
      "key": "cleanser",
      "title": "Facial Cleanser",
      "description": "Care for mature facial skin with a cleanser that helps remove daily buildup and leaves skin feeling soft before the rest of your facial routine.",
      "image": "assets/acfup-cleanser.png",
      "imageAlt": "Facial Cleanser product packshot",
      "provenance": {
        "source": "https://miamimd.co/assets/images/products/facial-cleanser/facial-cleanser-shopImg.png",
        "sourcePackPath": "facial-cleanser/facial-cleanser_packshot_1.png",
        "status": "live-on-brand-site",
        "sha256": "5c267e1993db6ce3834bdc2b5657b98e9fd697f98a6e73e89de8089e03323f8d",
        "packagingApproved": false
      },
      "productId": "15485375807773",
      "variantId": 67911977369885,
      "catalogPriceCents": 2730,
      "catalogPriceStatus": "Current catalog price matches approved one-time preview offer; purchasing and fulfillment remain disabled",
      "approvedOfferPriceCents": 2730,
      "sellingPlanId": null,
      "warehouseVerified": false,
      "previewOnly": true,
      "purchaseEnabled": false,
      "routineRole": "Start with a gentle cleanse",
      "copySource": "https://miamimd.co/facial-cleanser",
      "contextDescription": {
        "acf": "For your separate facial routine, a cleanser that helps remove daily buildup and leaves skin feeling soft.",
        "lf": "Start your facial routine with a cleanser that helps remove daily buildup and leaves skin feeling soft."
      },
      "catalogPreviousReference": {
        "productId": "15479673028893",
        "variantId": null,
        "catalogPriceCents": 3900
      },
      "sku": "MMFC-1B",
      "handle": "miamimd-facial-cleanser-1-tube-special",
      "catalogFamily": "special",
      "catalogSource": "https://crepe.trymiamimd.com/products/miamimd-facial-cleanser-1-tube-special.js",
      "publicPlanReadbackVerified": false,
      "fulfillmentVerificationRequired": true,
      "pricingApproved": true,
      "offerQuantity": 1,
      "catalogPriceVerifiedDate": "2026-10-30",
      "offerPriceApprovedDate": "2026-10-30"
    },
    {
      "key": "lip",
      "title": "Lip Plumper",
      "description": "If the look of thinning lips is another concern, add an optional cosmetic finishing step for fuller-looking lips.",
      "image": "assets/acfup-lip.png",
      "imageAlt": "Lip Plumper product packshot",
      "provenance": {
        "source": "https://miamimd.co/assets/images/products/lip-plumper/lip-plumper-shopImg.png",
        "sourcePackPath": "lip-plumper/lip-plumper_packshot_1.png",
        "status": "live-on-brand-site",
        "sha256": "d5e01f91b355d9dc298ed894208ce81b90a47aa84c99ccca18fd2d476b68b5c6",
        "packagingApproved": false
      },
      "productId": "15485384884509",
      "variantId": 67912075903261,
      "catalogPriceCents": 3300,
      "catalogPriceStatus": "Current catalog price matches approved one-time preview offer; purchasing and fulfillment remain disabled",
      "approvedOfferPriceCents": 3300,
      "sellingPlanId": null,
      "warehouseVerified": false,
      "previewOnly": true,
      "purchaseEnabled": false,
      "routineRole": "A fuller-looking finish",
      "copySource": "https://miamimd.co/lip-plumper",
      "catalogPreviousReference": {
        "productId": "15479673225501",
        "variantId": null,
        "catalogPriceCents": 6900
      },
      "sku": "MMLP-1B",
      "handle": "miamimd-lip-plumper-1-bottle-special",
      "catalogFamily": "special",
      "catalogSource": "https://crepe.trymiamimd.com/products/miamimd-lip-plumper-1-bottle-special.js",
      "publicPlanReadbackVerified": false,
      "fulfillmentVerificationRequired": true,
      "pricingApproved": true,
      "offerQuantity": 1,
      "catalogPriceVerifiedDate": "2026-10-30",
      "offerPriceApprovedDate": "2026-10-30"
    },
    {
      "key": "dsc",
      "title": "Dark Spot Corrector",
      "description": "If dark spots are another concern alongside skin texture, explore targeted care for the look of uneven tone on areas such as hands and chest.",
      "image": "assets/acfup-dsc.png",
      "imageAlt": "Dark Spot Corrector product packshot",
      "provenance": {
        "source": "trymiamimd.com live page",
        "sourcePackPath": "dark-spot-corrector/live-v42-upsell4-dsc/assets/dark-spot-corrector-single.D9XvZsVf.png",
        "status": "statsig-variant",
        "sha256": "0ff2e07b9539fb6ef4eaf8e6e410ab5c5277c6b3914af3769c2384cc1fc3cf92",
        "packagingApproved": false
      },
      "productId": "15485350543645",
      "variantId": 67911687602461,
      "catalogPriceCents": 3300,
      "catalogPriceStatus": "Current catalog price matches approved one-time preview offer; purchasing and fulfillment remain disabled",
      "approvedOfferPriceCents": 3300,
      "sellingPlanId": null,
      "warehouseVerified": false,
      "previewOnly": true,
      "purchaseEnabled": false,
      "routineRole": "Care for uneven tone, too",
      "copySource": "https://miamimd.co/dark-spot-corrector",
      "contextDescription": {
        "acf": "If uneven tone is a separate concern, explore targeted dark-spot care. This is optional and distinct from your body texture routine.",
        "lf": "If uneven tone is another facial-care concern, explore optional targeted dark-spot care."
      },
      "catalogPreviousReference": {
        "productId": "15479671357725",
        "variantId": null,
        "catalogPriceCents": 6900
      },
      "sku": "MMDSC-1B",
      "handle": "miamimd-dark-spot-corrector-1-bottle-special",
      "catalogFamily": "special",
      "catalogSource": "https://crepe.trymiamimd.com/products/miamimd-dark-spot-corrector-1-bottle-special.js",
      "publicPlanReadbackVerified": false,
      "fulfillmentVerificationRequired": true,
      "pricingApproved": true,
      "offerQuantity": 1,
      "catalogPriceVerifiedDate": "2026-10-30",
      "offerPriceApprovedDate": "2026-10-30"
    }
  ],
  "iweImages": [
    {
      "src": "assets/acfup-iwe.png",
      "alt": "Instant Wrinkle Eraser For Eyes bottle and carton",
      "caption": "MiamiMD Instant Wrinkle Eraser For Eyes",
      "source": "https://miamimd.co/assets/images/products/instant-wrinkle-eraser/instant-wrinkle-eraser-shopImg.png"
    },
    {
      "src": "assets/acfup-iwe-single.png",
      "alt": "Close view of the Instant Wrinkle Eraser For Eyes bottle",
      "caption": "A closer look at the For Eyes bottle",
      "source": "https://miamimd.co/assets/images/products/instant-wrinkle-eraser/instant-wrinkle-eraser-variant-01.png"
    }
  ],
  "tbmEvidence": {
    "vitaminCPerServingMg": 225,
    "servingCapsules": 2,
    "marineCollagenAmountMg": null,
    "label": "https://miamimd.co/assets/images/products/total-beauty-matrix/total-beauty-matrix-ingredients-05.png",
    "support": "https://ods.od.nih.gov/factsheets/VitaminC-HealthProfessional/",
    "limitation": "No product-specific clinical improvement in crepey skin or faster Advanced Crepe Fix results established in supplied evidence."
  },
  "catalogRegistryVersion": "emanuel-catalog-20261029",
  "iweOffer": {
    "amountCents": 3300,
    "pricingApproved": true,
    "enabled": false,
    "previewOnly": true
  }
};
